// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"9d482caa","297":"19e357e8","643":"9949bc00"}[chunkId] + ".chunk.js";
};